
import ActionTypes from './ActionTypes';

const getUser = payload => {
    return {
        type: ActionTypes.GET_USER,
        payload: payload,
    };
};


const changeThemeColor = payload => {
    return {
        type: ActionTypes.ChangeThemeColor,
        payload: payload,
    };
};

const changeThemeFont = payload => {
    return {
        type: ActionTypes.ChangeThemeFont,
        payload: payload,
    };
};

const UpdateUserProfile = payload => {
    return {
        type: ActionTypes.UpdateUserProfile,
        payload: payload,
    };
};
const NotificationSwitch = payload => {
    return {
        type: ActionTypes.NotificationSwitch,
        payload: payload,
    };
};

const isLogin = payload => {
    return {
        type: ActionTypes.IsLogin,
        payload: payload,
    };
};

const isLogout = payload => {
    return {
        type: ActionTypes.IsLogout,
        payload: payload,
    };
};


export { getUser, changeThemeColor, changeThemeFont, UpdateUserProfile, NotificationSwitch, isLogin, isLogout };